import React from "react";
import moment from "moment"
import Formatter from "../../utils/Formatter";
const MSDUserInfo = ({ myStudentData, isEditing }) => {
  const getIDRAnniversaryDate = (msd) => {
    if (!msd || !msd.student_loans) {
      return "N/A";
    }

    const allLoans = [];
    for (let i = 0; i < msd.student_loans.length; i++) {
      for (let j = 0; j < msd.student_loans[i].loans.length; j++) {
        const loan = msd.student_loans[i].loans[j];
        // Calculate total outstanding balance
        const totalBalance = (Formatter.moneyToNumber(loan.loan_outstanding_interest_balance) || 0)
          + Formatter.moneyToNumber(loan.loan_outstanding_principal_balance || 0);
        if (totalBalance > 0 && loan.loan_repayment_idr_anniversary) {
          allLoans.push(loan.loan_repayment_idr_anniversary);
        }
      }
    }
    const uniqueLoans = Array.from(new Set(allLoans));

    if (uniqueLoans.length === 0) {
      return "N/A";
    }

    const farthestDate = uniqueLoans.reduce((max, current) => {
      return moment(current, "MM/DD/YYYY").isAfter(moment(max, "MM/DD/YYYY")) ? current : max;
    });

    return farthestDate;
  };
  if (isEditing) {
    return <div className="row">
      <div className="col-12 text-center">
        <p>On File - MSD Information</p>
        <div>
          <p><small>You can't edit the information on users MSD File. Ask user to contact servicer if they would like to change their information</small></p>
        </div>
      </div>
    </div>
  }
  return <>
    <div className="row">
      <div className="col-3">
        <div className="info-block">
          <div>
            <label>First Name on File</label>
            {myStudentData.firstname || 'Unknown'}
          </div>
        </div>
      </div>
      <div className="col-3">
        <div className="info-block">
          <div>
            <label>Middle Name on File</label>
            {myStudentData.mi || 'Unknown'}
          </div>
        </div>
      </div>
      <div className="col-3">
        <div className="info-block">
          <div>
            <label>Last Name on File</label>
            {myStudentData.lastname || 'Unknown'}
          </div>
        </div>
      </div>
      <div className="col-3">
        <div className="info-block">
          <div>
            <label>Email on File</label>
            {myStudentData.email || 'Unknown'}
          </div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-3">
        <div className="info-block">
          <div>
            <label>Address Line 1 on File</label>
            {myStudentData.address1 || 'Unknown'}
          </div>
        </div>
      </div>
      <div className="col-3">
        <div className="info-block">
          <div>
            <label>Address Line 2 on File</label>
            {myStudentData.address2 || 'Unknown'}
          </div>
        </div>
      </div>

      <div className="col-3">
        <div className="info-block">
          <div>
            <label>City on File</label>
            {myStudentData.city || 'Unknown'}
          </div>
        </div>
      </div>
      <div className="col-3">
        <div className="info-block">
          <div>
            <label>Zip on File</label>
            {myStudentData.zip || 'Unknown'}
          </div>
        </div>
      </div>
    </div>
    <div className="row">
      <div className="col-3">
          <div className="info-block">
            <div>
              <label>State on File</label>
              {myStudentData.state || 'Unknown'}
            </div>
          </div>
        </div>
        <div className="col-3">
          <div className="info-block">
            <div>
              <label>MSD IDR Anniversary Date</label>
              {getIDRAnniversaryDate(myStudentData)}
            </div>
          </div>
        </div>
    </div>
  </>
}

export default MSDUserInfo;
